import { Component, computed, inject, input } from '@angular/core';

import { CmsCollection } from '@fcom/core-api';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';
import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';

@Component({
  selector: 'cms-badge',
  styleUrls: ['cms-badge.component.scss'],
  templateUrl: 'cms-badge.component.html',
  standalone: false,
})
export class CmsBadgeComponent {
  private themeService = inject(FinnairThemeService);

  content = input.required<CmsCollection>();

  isNewBrand = computed(() => this.themeService.siteTheme() !== FinnairTheme.LEGACY);
}
